import { SignOrderLabel } from "./ui/sign-order-label";
import { SignerRejection } from "./ui/signer-rejection";
import { SignSignatureStatusTag } from "./ui/sign-signature-status-tag";

/**
 * Состояние подписи подписанта: статус, отказ и очередь. Отказ и очередь принимают фрагмент
 * подписанта (`data`), объявленный на каждом его DTO; статус — значение enum, как тег стадии.
 */
export const SignSignature = {
  StatusTag: SignSignatureStatusTag,
  Rejection: SignerRejection,
  Order: SignOrderLabel,
};
